import { useMutation } from 'react-query';

import { NewForumPost, createForumPost } from '../utils/backend-api/forumPosts';

export default function useForumPostCreate() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation((values: NewForumPost) =>
    createForumPost(values)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
